import React from 'react'
import footerLogo from '../../assets/logo-footer.png'
import facebook from '../../assets/ic_sharp-facebook.png'
import instagram from '../../assets/insta.png'
import twitter from '../../assets/twitter.png'
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Home, Wrench } from 'lucide-react'

export default function MainFooter() {

    return (
        <footer id="contact" className="bg-navy text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="space-y-4">
              <div className="flex items-center">
              <img src={footerLogo} className="h-10 sm:h-12" alt="Rekebisha Logo" />
              </div>
              <p className="text-gray-300">
                Kenya's marketplace for homes and fundis. Find a house to let or buy, or hire a verified handyman, and deal directly with the person on the other side.
              </p>
              <div className="flex space-x-4">
                <button type="button" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">
                  <img src={facebook} className="w-6 h-6" alt="Facebook" />
                </button>
                <button type="button" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">
                  <img src={instagram} className="w-6 h-6" alt="Instagram" />
                </button>
                <button type="button" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">
                  <img src={twitter} className="w-6 h-6" alt="Twitter" />
                </button>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">Home</Link></li>
                <li><Link to="/find-rental" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">Properties</Link></li>
                <li><Link to="/find-fundi" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">Find a Fundi</Link></li>
                <li><Link to="/about-us" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">About Us</Link></li>
                <li><Link to="/faqs" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">FAQs</Link></li>
                <li><Link to="/contact-us" className="text-gray-300 hover:text-brandgreen transition-colors duration-300">Contact</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Contact Info</h3>
              <div className="space-y-2">
                <div className="flex items-center">
                  <Phone className="w-5 h-5 mr-2 text-brandgreen" />
                  <span className="text-gray-300">0733 212 124</span>
                </div>
                <div className="flex items-center">
                  <Mail className="w-5 h-5 mr-2 text-brandgreen" />
                  <span className="text-gray-300">info@rekebisha.com</span>
                </div>
                <div className="flex items-center">
                  <MapPin className="w-5 h-5 mr-2 text-brandgreen" />
                  <span className="text-gray-300">Nairobi, Kenya</span>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">The Rekebisha App</h3>
              <div className="space-y-2">
                <div className="flex items-center text-gray-300">
                  <Home className="w-5 h-5 mr-2 flex-shrink-0 text-brandgreen" />
                  <span>Browse verified homes to let or buy</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <Wrench className="w-5 h-5 mr-2 flex-shrink-0 text-brandgreen" />
                  <span>Hire rated fundis across all 47 counties</span>
                </div>
                <div className="text-gray-300">Talk directly to the owner, agent or fundi. No middlemen.</div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-12 pt-8 text-center">
            <p className="text-gray-400">
              Copyright 2026 Rekebisha, Kenya's marketplace for homes and fundis. All rights reserved.
              <span className="text-brandgreen font-bold"> Developed by <a href='https://www.dreamingrose.co.ke/' className='text-white font-semibold'>Dreaming Rose Limited</a></span>
            </p>
          </div>
        </div>
      </footer>
    )
}
